import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Table from '../../../common/Table';
import { BANK_RECONCILIATION_CORPORATE_COVERAGE_COLUMNS } from '../../../../config/columns';
import {
  getBankReconciliationCorporates,
  clearBankReconciliationCorporates,
} from '../../../../actions';
import BankReconciliationCorporateManualVouchersTable from './BankReconciliationCorporateManualVouchersTable';

const BankReconciliationCorporateCoverageTable = ({
  date,
  corporates,
  loading,
  dispatchGetBankReconciliationCorporates,
  dispatchClearBankReconciliationCorporates,
}) => {
  useEffect(() => {
    dispatchGetBankReconciliationCorporates({ date });

    return () => dispatchClearBankReconciliationCorporates({ date });
  }, [date]);

  // Stable reference so parent reloads keep expanded rows open
  const data = useMemo(() => corporates.toJS(), [corporates]);

  const renderManualVouchersTable = ({
    original: { holderType, corporateId, currency, businessName },
  }) => (
    <BankReconciliationCorporateManualVouchersTable
      date={date}
      holderType={holderType}
      corporateId={corporateId}
      currency={currency}
      businessName={businessName}
    />
  );

  const [year, month, day] = date.split('-');

  return (
    <div className="p-3 pl-4 bg-light border-top">
      <h6 className="text-muted">
        Cobertura de corporativos del {`${day}/${month}/${year}`}
      </h6>
      <Table
        columns={BANK_RECONCILIATION_CORPORATE_COVERAGE_COLUMNS}
        data={data}
        loading={loading}
        manual={false}
        showPagination={false}
        pageSize={data.length || 1}
        groupedColumns
        collapseOnDataChange={false}
        rowComponent={renderManualVouchersTable}
      />
    </div>
  );
};

BankReconciliationCorporateCoverageTable.propTypes = {
  date: PropTypes.string.isRequired,
  corporates: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool,
  dispatchGetBankReconciliationCorporates: PropTypes.func.isRequired,
  dispatchClearBankReconciliationCorporates: PropTypes.func.isRequired,
};

BankReconciliationCorporateCoverageTable.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ SalesUnit }, { date }) => ({
  corporates:
    SalesUnit.BankReconciliation.getIn(['corporatesByDate', date, 'content']) ||
    Immutable.List(),
  loading:
    SalesUnit.BankReconciliation.getIn(['corporatesByDate', date, 'loading']) ||
    false,
});

const mapDispatchToProps = {
  dispatchGetBankReconciliationCorporates: getBankReconciliationCorporates,
  dispatchClearBankReconciliationCorporates: clearBankReconciliationCorporates,
};

export { BankReconciliationCorporateCoverageTable };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BankReconciliationCorporateCoverageTable);
